var map = {
	"./i18n/ar.json": [
		15991,
		"src_app_modules_features_payroll_sections_report_reports_report-child_i18n_ar_json"
	],
	"./i18n/en-CA.json": [
		80052,
		"src_app_modules_features_payroll_sections_report_reports_report-child_i18n_en-CA_json"
	],
	"./i18n/en-US.json": [
		74071,
		"src_app_modules_features_payroll_sections_report_reports_report-child_i18n_en-US_json"
	],
	"./i18n/es-MX.json": [
		50467,
		"src_app_modules_features_payroll_sections_report_reports_report-child_i18n_es-MX_json"
	],
	"./i18n/fr-CA.json": [
		45299,
		"src_app_modules_features_payroll_sections_report_reports_report-child_i18n_fr-CA_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 99780;
module.exports = webpackAsyncContext;